//dependencias
import React, { Component } from 'react';

//componentes
import PlanEMAction from './planEvaluacionM'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanEMAction />
            </div>
        );
    }

}
export default Index;